import { BarChart3, Clock, Globe2, IndianRupee } from "lucide-react";
import Reveal from "../Reveal";

const STATS = [
  { icon: BarChart3, value: "250+", label: "Markets & pairs" },
  { icon: Clock, value: "24/7", label: "Trading access" },
  { icon: IndianRupee, value: "INR", label: "UPI & bank rails" },
  { icon: Globe2, value: "Global", label: "Liquidity venues" },
];

export default function LandingStatsStrip() {
  return (
    <section
      className="border-b border-[var(--cm-border)] bg-white"
      data-testid="landing-stats-strip"
    >
      <div className="cm-container py-8 lg:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.label}
                variant="fade-up"
                delay={i * 60}
                className="flex items-center gap-4 rounded-[16px] border border-[var(--cm-border)] bg-cm-surface/60 px-5 py-4 lg:py-5 cm-hover-lift"
              >
                <div className="w-11 h-11 rounded-xl bg-white border border-[var(--cm-border)] grid place-items-center shrink-0 shadow-sm">
                  <Icon size={20} className="text-cm-blue" strokeWidth={1.75} />
                </div>
                <div>
                  <div className="text-[22px] lg:text-[26px] font-extrabold text-cm-navy tracking-tight leading-none">
                    {s.value}
                  </div>
                  <div className="mt-1 text-[12px] text-cm-grey font-medium">{s.label}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
